export const AGENT_COLORS = {
  Jarvis: '#7C6AF7', Scout: '#22C55E', Quill: '#F59E0B', Henry: '#EC4899', Sentinel: '#EF4444',
};
export const TAG_COLORS = {
  'Core Engine':'#3B5BDB','ML Research':'#6741D9','Infrastructure':'#1971C2',
  'Documentation':'#0F9E6E','Safety':'#C2410C','QA':'#0369A1',
  'Security':'#7C3AED','Marketing':'#B45309','Content':'#047857','Research':'#6D28D9',
};
export const COLUMNS = ['Backlog','In Progress','Review','Done'];
export const NAV_ITEMS = [
  { icon:'⊞', label:'Tasks',           id:'tasks'            },
  { icon:'◈', label:'Agents',          id:'agents'           },
  { icon:'✦', label:'Content',         id:'content'          },
  { icon:'✓', label:'Approvals',       id:'approvals',        badge:'approvals' },
  { icon:'⬡', label:'Council',         id:'council'          },
  { icon:'◎', label:'Pipeline',        id:'pipeline'         },
  { icon:'🎨', label:'Creative Engine', id:'creative-engine'  },
  { icon:'📊', label:'Ossia',          id:'ossia'            },
  { icon:'▣', label:'Projects',        id:'projects'         },
  { icon:'◉', label:'Memory',          id:'memory'           },
  { icon:'📄', label:'Docs',           id:'docs'             },
  { icon:'👥', label:'Team',           id:'team'             },
  { icon:'📡', label:'Radar',          id:'radar'            },
];
export const PRIORITY_COLOR = { HIGH:'#EF4444', MEDIUM:'#F59E0B', LOW:'#22C55E' };
export const STATUS_DOT = {
  'Backlog':'#4B5563','In Progress':'#4F6EF7','Review':'#F59E0B','Done':'#22C55E',
};
